export default "__VITE_ASSET__CxPiz6TI__"